import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';
import { CreationAccesOrder } from './creation-acces-order.entity';
import { NotifiableByMailOrder } from './has-id.interface';

export class CreationGrantedAccesOrder extends CreationAccesOrder implements NotifiableByMailOrder {
	dateAutorisation!: LocalDateTime | null;;
	controleSecurite!: number | null;

	forceMailsAsTest?: boolean;

	constructor() {
		super();
	}
}